import React, { PropsWithChildren, ReactElement } from 'react';

export type PhyscialConnectionGroupProps = PropsWithChildren<unknown>;

export const PhysicalConnectionGroup = ({
  children,
}: PhyscialConnectionGroupProps): ReactElement => (
  <g data-group="physical-connections-group">{children}</g>
);
